module.exports = {"unspecified":"Не выбрана","horde":"Орда","alliance":"Альянс"};